import React  from 'react';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import { IconButton, InputAdornment, OutlinedInput } from "@mui/material"
import { memo, useState } from 'react';
import { useRecoilValue } from 'recoil';
import { errorsReservationUserState, valuesFormReservationUserState } from 'src/Patient/state/atoms';
import HelperTextInput from 'src/shared/components/alerts/HelperTextInput';
import InputLabelCustom from "src/shared/components/forms/InputLabelCustom"
import useAuthPatient from '../hooks/useAuthPatient';

const PasswordLoginField = memo(({ onKeyEnter }) => {
    const errorsReservationUser = useRecoilValue(errorsReservationUserState);
    const valuesFormReservationUser = useRecoilValue(valuesFormReservationUserState)
    const [showPassword, setShowPassword] = useState(false)
    const { handleChange } = useAuthPatient()
    const handleClickShowPassword = () => {
        setShowPassword(!showPassword);
    };

    const handleMouseDownPassword = (event) => {
        event.preventDefault();
    };

    let propsTextFieldPassword = {};
    if(onKeyEnter) {
        propsTextFieldPassword['onKeyPress'] = (ev) => {
            if (ev.key === "Enter") {
                onKeyEnter();
            }
        }
    }

    return (
        <>
            <InputLabelCustom htmlFor="input-password" text="Contraseña" />
            <OutlinedInput
                id="input-pass"
                size="small"
                error={errorsReservationUser['uswClave'] && errorsReservationUser['uswClave'].length > 0 ? true : false}
                style={{ width: '100%' }}
                name="uswClave"
                type={showPassword ? 'text' : 'password'}
                value={valuesFormReservationUser.uswClave || ""}
                variant="outlined"
                onChange={handleChange}
                autoComplete="off"
                placeholder="********"
                endAdornment={
                    <InputAdornment position="end">
                        <IconButton
                            aria-label="toggle password visibility"
                            onClick={handleClickShowPassword}
                            onMouseDown={handleMouseDownPassword}
                        >
                            {showPassword ? <VisibilityOff /> : <Visibility />}
                        </IconButton>
                    </InputAdornment>
                }

                {...propsTextFieldPassword}
            />
            {
                errorsReservationUser['uswClave'] && errorsReservationUser['uswClave'].length > 0 ?
                <HelperTextInput messages={errorsReservationUser['uswClave']} />
                : null
            }
        </>
    )
})

export default PasswordLoginField;